import { useCallback, useState } from 'react';
import { CameraImageModel } from 'api/models';

const useImageSliderState = () => {
    const [images, setImages] = useState<CameraImageModel[]>([]);
    const [selectedImage, setSelectedImage] = useState<CameraImageModel>(null);
    const [selectedDate, setSelectedDate] = useState<string>(null);
    const [startDate, setStartDate] = useState<string>(null);
    const [endDate, setEndDate] = useState<string>(null);

    const setState = useCallback(
        (data: { images: CameraImageModel[]; startDate: string; endDate: string; index: number }) => {
            setImages(data.images);

            setStartDate(data.startDate);

            setEndDate(data.endDate);

            if (data.images.length > 0) {
                setSelectedImage(data.images[data.index]);

                // To set the date first time
                setSelectedDate(data.images[data.index].date);
            }
        },
        []
    );

    const resetState = useCallback(() => {
        setImages([]);

        setSelectedImage(null);

        setSelectedDate(null);

        setStartDate(null);

        setEndDate(null);
    }, []);

    return {
        images,
        setImages,
        selectedImage,
        setSelectedImage,
        selectedDate,
        setSelectedDate,
        endDate,
        setEndDate,
        startDate,
        setStartDate,
        setState,
        resetState,
    };
};

export default useImageSliderState;
